import ButtonStackWidget from './ButtonStackWidget';
import { TEXT } from "@mm/constants/widgets";

export default class TextWidget extends ButtonStackWidget {
  static make(pageId, text, sortOrder, isSmsRelated) {
    const widget = {
      ...super.make(pageId, TEXT, sortOrder, isSmsRelated),
    };

    delete widget.label;

    return {
      ...widget,
      config: {
        ...widget.config,
        body: text,
      },
    };
  }
}
